import { ApolloLink } from '@apollo/client';

function getLogMiddleware(logger, openQueryChecker) {
  return new ApolloLink((operation, forward) => {
    const requestId = openQueryChecker.getRequestId();
    openQueryChecker.openQueries.add(requestId);
    const log = setupLogger(requestId, operation);
    return forward(operation).map(response => {
      finishRequest(operation, log);
      return response;
    });
  });

  function finishRequest(operation, log) {
    openQueryChecker.openQueries.delete(operation.getContext().requestId);

    if (!log) return;

    const responseTime = (new Date() - operation.getContext().start) / 1000;
    log(`GraphQL Response took: ${responseTime}s`);
  }

  function setupLogger(requestId, operation) {
    operation.setContext({ requestId });

    if (!logger.enabled) return null;

    const log = logger.extend(requestId);
    log(`GraphQL Request: ${operation.operationName}`);
    log(`GraphQL variables: %O`, operation.variables);
    operation.setContext({ start: new Date(), requestId });
    return log;
  }
}

export default getLogMiddleware;
